import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect width="20" height="20" fill="#2970FF" rx="10"></rect>
      <path
        fill="#fff"
        d="M10 14.999c-.224 0-.455-.057-.657-.162l-.112-.056-1.958-1.132a1.474 1.474 0 01-.735-1.279v-1.075l.693.4v.654c0 .295.154.562.405.71l1.693.984c.035.02.07.028.112.028a.218.218 0 00.216-.218v-.759a.818.818 0 00-.405-.71l-4.79-2.782A.93.93 0 014 8.793a.93.93 0 01.462-.808l4.804-2.79C9.49 5.07 9.74 5 10 5s.51.07.734.196l4.805 2.79a.93.93 0 01.461.808.93.93 0 01-.461.809l-4.784 2.775a.818.818 0 00-.405.71v.76a.216.216 0 00.217.225.22.22 0 00.111-.03l1.693-.983a.818.818 0 00.405-.71v-.66l.693-.4v1.074c0 .527-.28 1.02-.735 1.28l-1.958 1.138-.112.063c-.21.098-.44.155-.664.155zm-.406-3.219a.84.84 0 00.406.113c.14 0 .287-.036.406-.113l2.014-1.166a.655.655 0 00-.056-.036L10.406 9.44A.84.84 0 0010 9.327a.752.752 0 00-.406.113l-1.958 1.138c-.02.014-.042.021-.056.036l2.014 1.166zm-.16-5.84a.22.22 0 00-.112.028L4.776 8.604a.222.222 0 00-.112.19c0 .077.042.147.112.19l2.161 1.25c.098-.105.21-.19.329-.26l1.972-1.146a.818.818 0 00.405-.71v-1.96a.208.208 0 00-.21-.218zm1.132 0a.218.218 0 00-.216.218v1.96c0 .296.154.563.405.71l1.972 1.146c.12.07.231.155.329.26l2.16-1.25a.222.222 0 00.113-.19.222.222 0 00-.112-.19L10.67 5.968a.196.196 0 00-.105-.028z"
      ></path>
    </svg>
  );
}

export default Icon;
